const state = {
	hoveredLocationID: null,
	locations: [],
	cssSelector: '',
	padding: {},
	markers: {
		searching: [],
		journey: [],
	}
}

const getters = {
	hoveredLocationID: state => state.hoveredLocationID,
	locations: state => state.markers,
	cssSelector: state => state.cssSelector,
	padding: state => state.padding,
	markers: state => {
		let markers = state.markers[state.status]
		return Array.isArray(markers) ? markers : []
	},
	searchingMarkers: state => state.markers.searching,
	journeyMarkers: state => state.markers.journey,
	journeyDestinationDetails: state => state.markers.journey.find(marker => marker.locationType === 'destination')
}

const mutations = {

	// Searching markers
	setSearchingMarkers(state, payload) {
		state.markers.searching = payload
	},
	clearSearchingMarkers(state) {
		state.markers.searching = []
	},

	/**
	 * If a marker with the specified location type is not already in the array
	 * append the new marker, otherwise overwrite it with the updated marker.
	 */
	setJourneyMarker(state, {newMarker, locationType}) {
		const index = state.markers.journey.findIndex(marker => marker.locationType === locationType)
		if (index === -1)
			state.markers.journey.push(newMarker)
		else
			state.markers.journey[index] = newMarker
	},

	/**
	 * Remove any markers with the specified location type
	 */
	clearJourneyMarker(state, locationType) {
		state.markers.journey = state.markers.journey.filter(marker => marker.locationType !== locationType)
	},

	/**
	 * Remove all journey markers
	 */
	clearAllJourneyMarkers: (state) => state.markers.journey = [],

	setHoveredLocationID(state, id) {
		state.hoveredLocationID = id
	},
	clearHoveredLocationID(state) {
		state.hoveredLocationID = null
	},
	setCssSelector(state, selector) {
		state.cssSelector = selector
	},
	setMapPadding(state, padding) {
		state.padding = padding
	}
}

const actions = {
	storeMapPadding({ commit }, payload) {
		commit('setMapPadding', payload)
	}
}

export default { namespaced: true, state, getters, mutations, actions }
